import * as types from '../../action-types';
import { getBrokerMetricsByIso as initialState } from "../../initialState";

const getBrokerMetricsByIso = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_BROKER_METRICS_BY_ISO_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_BROKER_METRICS_BY_ISO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_BROKER_METRICS_BY_ISO_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_BROKER_METRICS_BY_ISO_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getBrokerMetricsByIso;
